import React, { createContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import * as CertificadoApi from 'api/certificado';
import { getResponseError } from 'util/errorHelper';

const CertificadoContext = createContext({
  data: [],
  loading: false,
  error: null,
  fetch: () => {},
});

export const CertificadoContextProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async (filtro) => {
    try {
      const { data: response } = await CertificadoApi.buscar(filtro);

      if (response && response.length && Array.isArray(response)) {
        setData(response.map((item) => {
          const { assinatura } = item;
          if (assinatura === undefined) {
            item.assinatura = [];
          }
          const responsavel = assinatura !== undefined ? assinatura.map((ass) => ass.responsavel).toString().replace(',', '/') : '';
          return {
            ...item,
            responsavel,
          };
        }));
      } else {
        setData([]);
      }
    } catch (err) {
      setError(getResponseError(err));
    } finally {
      setLoading(false);
    }
  }, [setData, setLoading, setError]);

  return (
    <CertificadoContext.Provider value={{
      data,
      fetch,
      loading,
      error,
    }}
    >
      {children}
    </CertificadoContext.Provider>
  );
};

CertificadoContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CertificadoContext;
